module.exports = __webpack_public_path__ + "static/img/16.426d4cf4.png";